import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function PainPoints() {
  const problems = ['Buscás protocolos online que nunca quedan bien para tu paciente específico', 'Planificaciones de alta clínica armadas entre turno y turno, a las corridas', 'Siempre los mismos ejercicios porque no tenés un banco de fichas serio', 'La pre-habilitación, la fase aguda, la re-educación de carga — sin sistema visual', 'Pacientes con distinto nivel de recuperación sin material diferenciado', 'Semana agotada, el mismo ciclo empieza de nuevo'];
  return <section className="w-full bg-[#0a1410] py-8 md:py-16" data-id="element-166">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-167">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-168">
          {/* Headline */}
          <h2 className="text-3xl md:text-5xl font-bold text-white text-center mb-4 md:mb-8 leading-tight" data-id="element-169">
            ¿Cuántas horas más vas a perder buscando protocolos que no encajan?
          </h2>

          {/* Emotional Copy */}
          <div className="text-center mb-6 md:mb-10 space-y-2 md:space-y-4" data-id="element-170">
            <p className="text-lg text-gray-300 leading-relaxed" data-id="element-171">
              Sos kinesiólogo, profe de educación física, entrenador personal o
              instructor de gym. Amás lo que hacés. Pero nadie te dijo que ibas
              a pasar las tardes buscando fichas que no encajan, armando
              protocolos a las corridas y llegando al lunes con material que
              "más o menos sirve
            </p>
            <p className="text-xl md:text-2xl font-bold text-amber-500" data-id="element-172">
              No es falta de capacidad. Es falta de un sistema.
            </p>
          </div>

          {/* Problems Table */}
          <div className="mb-6 md:mb-10" data-id="element-173">
            <h3 className="text-2xl font-bold text-white mb-4 md:mb-6 text-center" data-id="element-174">
              Lo que pasa sin el Atlas:
            </h3>
            <div className="bg-[#0f1f17] border border-red-900/30 rounded-lg overflow-hidden" data-id="element-175">
              <div className="divide-y divide-red-900/20" data-id="element-176">
                {problems.map((problem, index) => <motion.div key={index} initial={{
                opacity: 0,
                x: -20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: index * 0.1,
                duration: 0.4
              }} className="flex items-start gap-4 p-4" data-id="element-177">
                    <X className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-178" />
                    <p className="text-gray-300" data-id="element-179">{problem}</p>
                  </motion.div>)}
              </div>
            </div>
          </div>

          {/* Transition */}
          <motion.h3 initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-2xl md:text-4xl font-bold text-amber-500 text-center" data-id="element-180">
            ¿Y si esta fuera la última semana que pasó así?
          </motion.h3>
        </motion.div>
      </div>
    </section>;
}